import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, Form } from 'react-bootstrap'
import { toast } from '@CommonComponents/toast'
import { client } from '@Utils'
import { useStateValue } from '@State'
import { ltiOrgKeyManagement as endpoints } from '@URLS'

export const NewOrgModal = props => {
  const [, dispatch] = useStateValue()
  const addNewOrg = async () => {
    try {
      let resp = await client.post(endpoints.addNewOrg(), {
        internalOrgName: newOrgName,
      })
      toast.success("Successfully added new organization.")
      dispatch({ type: 'updateTable', tableData: resp.data.organizations })
    } catch (err) {
      console.log(err)
      toast.error("There was an error trying to create a new organization.")
    } finally {
      props.toggle(!props.show)
    }
  }

  const [newOrgName, updateNewOrgName] = useState('')

  const handleOrgNameChange = e => {
    updateNewOrgName(e.target.value)
  }

  return (
    <Modal show={props.show} onHide={() => props.toggle(!props.show)}>
      <Modal.Header closeButton>
        <Modal.Title>New Organization</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="orgName">
          <Form.Label>New Organization Name</Form.Label>
          <Form.Control
            type="text"
            onChange={handleOrgNameChange}
            value={newOrgName}
          />
        </Form.Group>
        <div
          className="btn btn-success btn-myed btn-success-myed"
          onClick={() => addNewOrg()}
        >
          <div className="fa-regular fa-plus fa-fw mr-2" /> Add Organization
        </div>
      </Modal.Body>
    </Modal>
  )
}

NewOrgModal.propTypes = {
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}
